module.exports = __webpack_public_path__ + "dae16f90a5f06059588e6e0819792265.svg";